import { Language } from "@smile2impress/attraction-constants";

import spain from "./spain";
import italy from "./italy";
import portugal from "./portugal";
import english from "./english";
import catalonia from "./catalonia";
import france from "./france";

export default (language: Language) => {
    switch (language) {
        case Language.FRANCE:
            return france;
        case Language.ITALY:
            return italy;
        case Language.PORTUGAL:
            return portugal;
        case Language.SPAIN:
            return spain;
        case Language.CATALONIA:
            return catalonia;
        case Language.ENGLISH:
            return english;
        default:
            return english;
    }
};
